import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class AnswerDropZone extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'CircleButton', this).setOrigin(0, 0);
    this.lbl = ABCyaPhaser.Images.addImage(0, 0, 'QuestionMark', this).setOrigin(0, 0);

    this.lbl.x = this.bg.getBounds().width / 2 - this.lbl.getBounds().width / 2;
    this.lbl.y = this.bg.getBounds().height / 2 - this.lbl.getBounds().height / 2;
  }

  showCorrect() {
    this.lbl.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, 'CorrectMark');
    this.lbl.x = this.bg.getBounds().width / 2 - this.lbl.getBounds().width / 2;
    this.lbl.y = this.bg.getBounds().height / 2 - this.lbl.getBounds().height / 2;
  };

  showIncorrect() {
    this.lbl.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, 'IncorrectMark');
    this.lbl.x = this.bg.getBounds().width / 2 - this.lbl.getBounds().width / 2;
    this.lbl.y = this.bg.getBounds().height / 2 - this.lbl.getBounds().height / 2;
  };

  showQuestionMark() {
    this.lbl.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, 'QuestionMark');
    this.lbl.x = this.bg.getBounds().width / 2 - this.lbl.getBounds().width / 2;
    this.lbl.y = this.bg.getBounds().height / 2 - this.lbl.getBounds().height / 2;
  };
}